module.exports = __webpack_public_path__ + "static/media/3.dc82888b.jpg";